import { useMemo } from 'react'
import { convertDateToMinutes } from '@/v2/utils/convert'
import { useDailyCalendar } from '@/v2/hooks/calendar/useCalendar'

export const useLoadData = date => {
  const { data, isLoading: loading, isError: error } = useDailyCalendar(date)
  const [dailyData] = data || []
  const appointments = dailyData?.appointments || []
  const timeOffs = dailyData?.timeOffs || []
  const clinicHours = dailyData?.hours || {}
  const startHour = loading
    ? null
    : getFirstHour(appointments, timeOffs, clinicHours)
  const endHour = loading
    ? null
    : getLastHour(appointments, timeOffs, clinicHours)

  return useMemo(
    () => ({
      loading,
      error,
      appointments,
      timeOffs,
      clinicHours,
      startHour,
      endHour,
    }),
    [loading, error, appointments, timeOffs, clinicHours, startHour, endHour]
  )
}

export const getFirstHour = (appointments, timeOffs, clinicHours) => {
  if (!clinicHours.isOpen) return 540

  const eventsStarts = [
    appointments[0] ? convertDateToMinutes(appointments[0].startsAt) : 540,
    timeOffs[0] ? convertDateToMinutes(timeOffs[0].startsAt) : 540,
  ]
  const hours = clinicHours.isOpen
    ? [...eventsStarts, convertDateToMinutes(clinicHours.opensAt)]
    : eventsStarts
  const sort = hours.sort((a, b) => (a > b ? 1 : -1))

  return sort[0] % 60 !== 0 ? sort[0] - (sort[0] % 60) : sort[0]
}

export const getLastHour = (appointments, timeOffs, clinicHours) => {
  if (!clinicHours.isOpen) return 1080

  const eventsStarts = [
    appointments[appointments.length - 1]
      ? convertDateToMinutes(appointments[appointments.length - 1].startsAt)
      : 1080,
    timeOffs[timeOffs.length - 1]
      ? convertDateToMinutes(timeOffs[timeOffs.length - 1].startsAt)
      : 1080,
  ]
  const hours = clinicHours.isOpen
    ? [...eventsStarts, convertDateToMinutes(clinicHours.closesAt)]
    : eventsStarts
  const sort = hours.sort((a, b) => (a < b ? 1 : -1))

  return sort[0] % 60 !== 45 ? sort[0] + 45 - (sort[0] % 60) : sort[0]
}
